// React
import { FunctionComponent } from "react"

//Bootstrap
import { OverlayTrigger, Tooltip } from "react-bootstrap"

//Constants
import vehicleIncidentColorSet from "src/pages/vehicle_incidents/constants/VehicleIncidentColorSet"

interface Props {
  label: string[]
  eventId: string
}

const formatLabel = (key: string) =>
  key.replace(/([A-Z])/g, " $1").trim().replace(/^./, (c) => c.toUpperCase())

const labelColor = (key: string) => vehicleIncidentColorSet[key] || "#888"

// Only the first label is shown so every row stays one line tall. The rest are
// summarised by a +N count and revealed on hover.
const VehicleIncidentsTableBodyTDIconBubble: FunctionComponent<Props> = ({ label, eventId }) => {
  if (label.length === 0) return null

  const [first, ...rest] = label

  const bubble = (
    <span className="VehicleIncidentsTableBodyTDIconGroup">
      <span className="VehicleIncidentsTableBodyTDIcon">
        <span
          className="VehicleIncidentsTableBodyTDIconDot"
          style={{ backgroundColor: labelColor(first) }}
        />
        {formatLabel(first)}
      </span>
      {rest.length > 0 ? (
        <span className="VehicleIncidentsTableBodyTDIconMore">+{rest.length}</span>
      ) : null}
    </span>
  )

  // A single-label event shows everything it has, so there is nothing to reveal.
  if (rest.length === 0) return bubble

  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="top"
      overlay={
        <Tooltip id={`vitb-labels-${eventId}`}>
          {label.map((l) => (
            <div key={l} className="VehicleIncidentsTableBodyTDIconTooltipRow">
              <span
                className="VehicleIncidentsTableBodyTDIconTooltipDot"
                style={{ backgroundColor: labelColor(l) }}
              />
              {formatLabel(l)}
            </div>
          ))}
        </Tooltip>
      }
    >
      {bubble}
    </OverlayTrigger>
  )
}

export default VehicleIncidentsTableBodyTDIconBubble
